import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AdminLayout from '../layouts/AdminLayout.vue'
import AuthLayout from '../layouts/AuthLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: '404' },
  },
  {
    name: 'app',
    path: '/',
    component: AdminLayout,
    meta: {
      requiresAuth: true,
    },
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/dashboard/Dashboard.vue'),
      },
      {
        name: 'products',
        path: 'products',
        component: () => import('../pages/products/ProductList.vue'),
      },
      {
        name: 'add-product',
        path: 'products/add',
        component: () => import('../pages/products/EditProduct.vue'),
      },
      {
        name: 'edit-product',
        path: 'products/edit/:productId',
        component: () => import('../pages/products/EditProduct.vue'),
      },
      {
        name: 'promocodes',
        path: 'promocodes',
        component: () => import('../pages/promocodes/PromoCodeList.vue'),
      },
      {
        name: 'shipping-fee',
        path: 'shipping-fee',
        component: () => import('../pages/shippingfee/ShippingFee.vue'),
      },
      {
        name: 'add-promocode',
        path: 'promocodes/add',
        component: () => import('../pages/promocodes/EditPromoCode.vue'),
      },
      {
        name: 'edit-promocode',
        path: 'promocodes/edit/:code',
        component: () => import('../pages/promocodes/EditPromoCode.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UserList.vue'),
      },
      {
        name: 'orders-by-keyword',
        path: 'orders/:keyword?',
        component: () => import('../pages/orders/OrderList.vue'),
      },
      {
        name: 'order-by-id',
        path: 'orders/detail/:orderId',
        component: () => import('../pages/orders/OrderDetail.vue'),
      },
      {
        name: 'orders',
        path: 'orders',
        component: () => import('../pages/orders/OrderList.vue'),
      },
      {
        name: 'coas',
        path: 'coas',
        component: () => import('../pages/coas/CertificateOfAnalysis.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/ChangeAdminPassword.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
